import React from 'react';
import {Link} from 'react-router-dom';
import Banner from 'ui/Banner/Banner';
import Raw from '../../ui/Raw/Raw';

const Office = ({count, locationCity, flagIcon}) => {
    const hasOpenings = count > 0 ? true : false;
    let openingsMessage = 'No Openings';
    if (hasOpenings) {
        openingsMessage = count > 1 ? `${count} Openings` : `${count} Opening`;
    }
    return (
        <dl className="careers-office text-center">
            <dt>
                {hasOpenings ? (
                    <Link to={`/careers/openings?location=${locationCity}`}>
                        <i className={flagIcon} aria-hidden="true" />
                        {locationCity}
                    </Link>
                ) : (
                    <span className="text-muted">{locationCity}</span>
                )}
            </dt>
            <dd>
                <small>{openingsMessage}</small>
            </dd>
        </dl>
    );
};

const Continent = ({title, imageUrl, offices}) => {
    return (
        <div className="continent">
            <img
                src={imageUrl}
                className="hidden-xs continent-img"
                alt=""
                role="presentation"
                aria-hidden="true"
            />
            <h2>{title}</h2>
            {offices
                .sort((a, b) => b.count - a.count)
                .map((office) => (
                    <Office {...office} key={office.title} />
                ))}
        </div>
    );
};

const Location = ({id, title, bgImageUrl, body, continents}) => (
    <section id={id}>
        <Banner image={bgImageUrl}>
            <h2 className="text-white">{title}</h2>
            <Raw content={body} className="text-constrained" />
        </Banner>
        <div className="container container--overlap">
            <div className="careers-columns text-center">
                {continents.map((continent) => (
                    <Continent {...continent} key={continent.title} />
                ))}
            </div>
        </div>
    </section>
);

export default Location;
